import axios from "@/lib/axios";
import { useMutation, useQuery } from "@tanstack/vue-query";
import { create } from "lodash";
import { ToastInterface, useToast } from "vue-toastification";

interface Props {
  immediate?: boolean;
  params?: Params;
}

interface Params {
  id: string | number;
}

interface CreateParams {
  id: string | number;
  email: string;
  type: string;
}

const getContactEmails = async (params: Params) => {
  const { data } = await axios.get(
    `/api/internal/contacts/${params.id}/emails`,
  );
  return data;
};

const createContactEmail = async (
  params: CreateParams,
  toast: ToastInterface,
) => {
  try {
    const { data } = await axios.post(
      `/api/internal/contacts/${params.id}/emails`,
      params,
    );

    toast.success("Se creo correctamente el email");

    return data;
  } catch (error: any) {
    toast.error(error.response.data.message);
  }
};

const updateContactEmail = async (
  params: CreateParams & { emailId: string | number },
  toast: ToastInterface,
) => {
  try {
    const { data } = await axios.put(
      `/api/internal/contacts/${params.id}/emails/${params.emailId}`,
      params,
    );

    toast.success("Se actualizo correctamente el email");

    return data;
  } catch (error: any) {
    toast.error(error.response.data.message);
  }
};

const useContactEmails = (props: Props = {}) => {
  const toast = useToast();

  const { data, isLoading, isError, refetch, isFetching } = useQuery(
    ["contact-emails", props.params],
    () => getContactEmails(props.params!),
    { enabled: props.immediate },
  );

  const createContactEmailMutation = useMutation((params: CreateParams) =>
    createContactEmail(params, toast),
  );

  const updateContactEmailMutation = useMutation(
    (params: CreateParams & { emailId: string | number }) =>
      updateContactEmail(params, toast),
  );

  return {
    contactEmails: data,
    isLoading,
    isError,
    refetch,

    createContactEmail: createContactEmailMutation.mutate,
    createContactEmailAsync: createContactEmailMutation.mutateAsync,
    createContactEmailLoading: createContactEmailMutation.isLoading,

    updateContactEmail: updateContactEmailMutation.mutate,
    updateContactEmailAsync: updateContactEmailMutation.mutateAsync,
    updateContactEmailLoading: updateContactEmailMutation.isLoading,

    isFetching,
  };
};

export default useContactEmails;
